import { stripHtmlTags } from '../../../../../Helpers/Misc'

export const courseDashboardSchema = ({
  name,
  teacherName,
  cover,
  instruments = [],
  description,
  preRequisites,
}) =>
  JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: name,
    description: description,
    coursePrerequisites: stripHtmlTags(preRequisites),
    image: cover,
    genre: instruments
      .reduce((merged, current) => `${merged}, ${current}`, '')
      .slice(2),
    author: {
      '@type': 'Person',
      name: teacherName,
    },
    creator: {
      '@type': 'Person',
      name: teacherName,
    },
    provider: {
      '@type': 'Person',
      name: teacherName,
    },
  })
